export function appendQueryParam(
  url: string,
  paramKey: string,
  paramValue: string | number | boolean
) {
  const hasQueryString = url.indexOf('?') !== -1;
  const paramString = `${paramKey}=${encodeURIComponent(paramValue)}`;
  return hasQueryString ? `${url}&${paramString}` : `${url}?${paramString}`;
}
